import { useState } from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const MISI = [
  "Menjamin akses informasi publik dan menyelenggarakan pelayanan informasi publik di bidang pendidikan tinggi, sains, dan teknologi sesuai dengan ketentuan peraturan perundang-undangan;",
  "Meningkatkan profesionalisme dan akuntabilitas Sumber Daya Manusia dalam memberikan pelayanan informasi publik di bidang pendidikan tinggi, sains, dan teknologi;",
  "Mengoptimalisasikan sarana prasarana pelayanan informasi publik agar lebih efektif dan efisien;",
  "Memanfaatkan teknologi informasi dan komunikasi yang mutakhir dan aman dalam memberikan pelayanan informasi publik di bidang pendidikan tinggi, sains, dan teknologi kepada masyarakat; dan",
  "Mendorong partisipasi publik dalam menyebarluaskan dan memanfaatkan informasi publik di bidang pendidikan tinggi, sains, dan teknologi.",
];

const TABS = [
  { id: "struktur", label: "Struktur PPID" },
  { id: "visi-misi", label: "Visi dan Misi PPID" },
];

const PEOPLE = [
  {
    testid: "profil-photo-atasan",
    src: "/kepala-lldikti7.jpg",
    imgClass: "h-52 w-full object-cover object-top md:h-64",
    label: "ATASAN PPID",
    name: "Prof. Dr. Dyah Sawitri, S.E., M.M.",
    role: "Kepala LLDIKTI Wilayah VII",
  },
  {
    testid: "profil-photo-ketua",
    src: "/ketua-ppid.jpg",
    imgClass: "h-52 w-full object-cover object-top md:h-64",
    label: "KETUA PPID",
    name: "Muhammad Machmud, S.Kom., M.Kom.",
    role: "Kepala Bagian Umum LLDIKTI Wilayah VII",
  },
];

export default function ProfilPpid() {
  const [tab, setTab] = useState("struktur");

  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Pusat Informasi — Profil PPID
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Profil PPID
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap gap-3">
            {TABS.map((t) => (
              <button
                key={t.id}
                type="button"
                data-testid={`profil-tab-${t.id}`}
                onClick={() => setTab(t.id)}
                className={`rounded-full px-6 py-3 text-xs font-bold tracking-[0.06em] transition-colors duration-200 ${
                  tab === t.id
                    ? "bg-[#0B2440] text-white"
                    : "bg-[#EFF6FC] text-[#0B2440] hover:bg-[#DCEBF7]"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </Reveal>

        {tab === "struktur" ? (
          <>
          <div
            data-testid="profil-panel-struktur"
            className="mt-12 grid gap-12 lg:grid-cols-[300px_1fr] lg:gap-16"
          >
            <Reveal>
              <div className="space-y-6">
                {PEOPLE.map((p) => (
                  <figure
                    key={p.testid}
                    data-testid={p.testid}
                    className="overflow-hidden rounded-3xl border border-[#E3EBF3] bg-[#F3F7FB]"
                  >
                    <img
                      src={p.src}
                      alt={`${p.name} — ${p.label}`}
                      className={p.imgClass}
                    />
                    <figcaption className="border-t border-[#E3EBF3] px-5 py-4">
                      <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
                        {p.label}
                      </p>
                      <p className="mt-2 font-display text-lg font-medium leading-snug text-[#0B2440]">
                        {p.name}
                      </p>
                      <p className="mt-1 text-xs text-slate-500">{p.role}</p>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="space-y-8 text-[15px] leading-relaxed text-slate-600 md:text-base">
                <p data-testid="profil-text-1">
                  Pejabat Pengelola Informasi dan Dokumentasi (PPID) dibentuk
                  dalam rangka meningkatkan transparansi dan akuntabilitas
                  publik. PPID berfungsi sebagai penghubung antara instansi
                  pemerintah dan masyarakat, memfasilitasi akses informasi yang
                  dibutuhkan oleh publik. Dengan adanya PPID, masyarakat dapat
                  lebih mudah mendapatkan informasi yang relevan dan berkaitan
                  dengan layanan publik, keputusan, serta kebijakan yang diambil
                  oleh pemerintah. Hal ini mendukung prinsip keterbukaan
                  informasi, yang merupakan salah satu pilar demokrasi.
                </p>
                <p data-testid="profil-text-2">
                  Selain itu, PPID juga berperan dalam mengurangi potensi
                  penyalahgunaan wewenang dan meningkatkan kepercayaan
                  masyarakat terhadap pemerintah. Dengan memberikan akses yang
                  lebih besar terhadap informasi publik, PPID dapat membantu
                  mencegah praktik korupsi dan ketidaktransparanan.
                </p>
                <p data-testid="profil-text-3">
                  Melalui PPID, LLDIKTI Wilayah VII berkomitmen meningkatkan
                  akses kepada masyarakat luas serta pengguna layanan terhadap
                  akses atas informasi, yang diharapkan akan dapat meningkatkan
                  partisipasi masyarakat dalam proses pengambilan keputusan,
                  kebijakan, strategi dan program pemerintahan yang dijalankan
                  LLDIKTI Wilayah VII.
                </p>
                <Link
                  to="/struktur-ppid"
                  data-testid="profil-struktur-selengkapnya"
                  className="inline-flex w-fit items-center justify-center rounded-full bg-[#0B2440] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#1479BF]"
                >
                  LIHAT STRUKTUR PPID SELENGKAPNYA
                </Link>
              </div>
            </Reveal>
          </div>
          </>
        ) : (
          <Reveal delay={0.15}>
            <div
              data-testid="profil-panel-visi-misi"
              className="mt-12 max-w-3xl space-y-10"
            >
              <p className="text-[15px] leading-relaxed text-slate-600 md:text-base">
                PPID LLDIKTI Wilayah VII sebagai bagian dari PPID Kementerian
                Pendidikan Tinggi, Sains, dan Teknologi (Kemdiktisaintek)
                menjalankan visi dan misi PPID Kemdiktisaintek, yaitu:
              </p>

              <div data-testid="profil-visi">
                <h2 className="font-display text-xl font-semibold text-[#0B2440] md:text-2xl">
                  Visi
                </h2>
                <div className="mt-3 h-1 w-14 rounded-full bg-[#E8A33D]" />
                <p className="mt-5 rounded-2xl border-l-4 border-[#1479BF] bg-[#F3F7FB] px-6 py-5 text-[15px] italic leading-relaxed text-slate-700 md:text-base">
                  Terwujudnya pelayanan informasi publik yang cepat, tepat
                  waktu, sederhana, dan berbiaya ringan untuk memenuhi hak
                  pemohon informasi di bidang pendidikan tinggi, sains, dan
                  teknologi sesuai dengan ketentuan peraturan
                  perundang-undangan.
                </p>
              </div>

              <div data-testid="profil-misi">
                <h2 className="font-display text-xl font-semibold text-[#0B2440] md:text-2xl">
                  Misi
                </h2>
                <div className="mt-3 h-1 w-14 rounded-full bg-[#E8A33D]" />
                <ol className="mt-5 space-y-4">
                  {MISI.map((m, i) => (
                    <li
                      key={i}
                      data-testid={`profil-misi-${i + 1}`}
                      className="flex gap-4 text-[15px] leading-relaxed text-slate-600 md:text-base"
                    >
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#0B2440] text-xs font-bold text-white">
                        {i + 1}
                      </span>
                      <span>{m}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </Reveal>
        )}
      </main>
      <Footer compact />
    </div>
  );
}
